import { useEffect, useRef } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import type { EditorState } from 'lexical';
import { CLEAR_EDITOR_COMMAND } from 'lexical';

export function EnterHitPlugin({ onHit }: { onHit: (editorState: EditorState) => void }) {
  const [editor] = useLexicalComposerContext();
  const refOnHit = useRef(onHit);

  useEffect(() => {
    refOnHit.current = onHit;
  }, [onHit]);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        refOnHit.current?.(editor.getEditorState());

        editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined);
      }
    };

    return editor.registerRootListener(
      (rootElement: null | HTMLElement, prevRootElement: null | HTMLElement) => {
        if (prevRootElement !== null) {
          prevRootElement.removeEventListener('keydown', onKeyDown);
        }
        if (rootElement !== null) {
          rootElement.addEventListener('keydown', onKeyDown);
        }
      },
    );
  }, [editor]);
  return null;
}
